import { render, staticRenderFns } from "./leadUserDetails.vue?vue&type=template&id=64752993&scoped=true&"
import script from "./leadUserDetails.vue?vue&type=script&lang=js&"
export * from "./leadUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./leadUserDetails.vue?vue&type=style&index=0&id=64752993&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64752993",
  null
  
)

export default component.exports